module.exports = __webpack_public_path__ + "static/media/NIH07123.33e8067c.jpg";